import Api from '@/api'
const resource = 'club_subscriptions'

export default {
  fetchClubPricing (payload) {
    return Api.post(`/${resource}/pricing`, payload)
  }
}
